import { HttpClient } from '@angular/common/http';
import {  Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/service/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  readonly currentYear = new Date().getFullYear();
  selectedLanguage: any = "en"
  submitted!: boolean;
  signupForm: FormGroup;
  isLoading: boolean = false;
  supportedLanguages: { code: string, name: string }[] = [
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' }
  ];
  constructor(private http: HttpClient, public router: Router, private formBuilder: FormBuilder,
    private userService: UserService,
    private translate: TranslateService,
    private toastr: ToastrService,) {
      translate.setDefaultLang('en');
      const savedLanguage = localStorage.getItem('selectedLanguage');
      if (savedLanguage) {
        this.selectedLanguage = savedLanguage;
        translate.use(savedLanguage);
      } else {
        translate.use('en');
      }
  }

  ngOnInit(): void {
    this.signupForm = this.formBuilder.group({
      first_name: [
        null,
        Validators.required,

      ],
      last_name: [null, Validators.required],
      company: [null, Validators.required],
      email: [
        null,
        [
          Validators.required,
          Validators.email,
          this.noWhitespaceValidator,
          Validators.pattern('^[aA-zZ0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      additional_info: [null]
    });

    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      this.selectedLanguage = storedLanguage;
    } else {
      this.selectedLanguage = 'en';
      localStorage.setItem('selectedLanguage', 'en');
    }
    this.translate.use(this.selectedLanguage);

  }

  get f(): { [key: string]: AbstractControl } {
    return this.signupForm.controls
  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  changeLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.userService.loadLang.next(lang);
   
  }


  signUp() {
    this.submitted = true;
    if (this.signupForm.invalid) {
      return;
    }
    let data = {
      first_name: this.signupForm.controls['first_name'].value,
      last_name: this.signupForm.controls['last_name'].value,
      company: this.signupForm.controls['company'].value,
      email: this.signupForm.controls['email'].value,
      additional_info: this.signupForm.controls['additional_info'].value
    };
    this.isLoading = true;
    this.userService.signUp(data).subscribe(
      (res) => {
        this.router.navigate(['/login']);
        this.isLoading = false;
        this.toastr.success(this.translate.instant('contactPage.sent'), '', { timeOut: 4000 });
      },
      () => {
        this.isLoading = false;
        this.toastr.error(this.translate.instant('authPages.generic'));
      }
    );
  }
}
